<div class="d-flex justify-content-between pb-3">
	<button mat-raised-button class="cancel-dialog" color="primary" (click)="closeDialog()">Wróć do rezerwacji</button>
	<button hidden="hidden" mat-raised-button color="primary">Wyślij oferty</button>
</div>
<div
	*ngIf="data.status === Status.CONFIRMED && data.type === OfferChangeTypes.CHANGE"
	class="bg-danger text-white mb-3 p-2 rounded-1"
>
	<ng-container *ngIf="data.oskarFault"> Gratis {{ data.term.gratis }} PLN </ng-container>
	<ng-container *ngIf="!data.oskarFault && surchargeService"
		>Powód zmiany: klient wyraził chęć zmiany, doliczone
		{{ surchargeService?.methodValue ? (surchargeService.methodValue | price) : 0 }}
		PLN
	</ng-container>
</div>
<div *ngIf="filtersLoaded" class="d-flex flex-wrap w-100">
	<ng-select
		appearance="outline"
		class="form-filter"
		placeholder="Destynacja"
		[(ngModel)]="filters.locations"
		[multiple]="true"
		(change)="setFilters()"
	>
		<ng-option *ngFor="let location of store.locations" [value]="location.id">{{ location.name }}</ng-option>
	</ng-select>

	<ng-select
		appearance="outline"
		class="form-filter"
		placeholder="Miasto wyjazdu"
		[(ngModel)]="filters.stops"
		[multiple]="true"
		(change)="setFilters()"
	>
		<ng-option *ngFor="let stop of store.stops" [value]="stop.id">{{ stop.location.name }}</ng-option>
	</ng-select>

	<mat-form-field class="form-filter" appearance="outline">
		<mat-label>Minimalna ilość noclegów:</mat-label>
		<input
			(change)="setFilters()"
			[(ngModel)]="filters.nightsMin"
			min="0"
			[value]="filters?.nightsMin?.toString()"
			type="number"
			matInput
		/>
	</mat-form-field>

	<mat-form-field class="form-filter" appearance="outline">
		<mat-label>Maksymalna ilość noclegów:</mat-label>
		<input
			(change)="setFilters()"
			[(ngModel)]="filters.nightsMax"
			[value]="filters?.nightsMax?.toString()"
			min="0"
			type="number"
			matInput
		/>
	</mat-form-field>

	<mat-form-field class="form-filter" style="padding: 0" appearance="outline">
		<mat-label>Termin</mat-label>
		<mat-date-range-input [rangePicker]="picker">
			<input matStartDate [(ngModel)]="filters.dateRange.lower" placeholder="Wyjazd" />
			<input matEndDate (dateChange)="setFilters()" [(ngModel)]="filters.dateRange.upper" placeholder="Powrót" />
		</mat-date-range-input>
		<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
		<i
			*ngIf="filters.dateRange.lower && filters.dateRange.upper"
			role="button"
			matDatepickerToggleIcon
			(click)="clearDate($event)"
			class="fas fa-times text-secondary"
		></i>
		<mat-date-range-picker #picker></mat-date-range-picker>
	</mat-form-field>

	<ng-select
		appearance="outline"
		class="form-filter"
		placeholder="Udogodnienia"
		[(ngModel)]="filters.conveniences"
		[multiple]="true"
		(change)="setFilters()"
	>
		<ng-option *ngFor="let convenience of store.conveniences" [value]="convenience.id">{{
			convenience.name
		}}</ng-option>
	</ng-select>

	<ng-select
		appearance="outline"
		[(ngModel)]="filters.roomTypes"
		[multiple]="true"
		(change)="setFilters()"
		class="form-filter"
		placeholder="Pokoje"
	>
		<ng-option *ngFor="let roomType of store.roomTypes" [value]="roomType.id">{{ roomType.name }}</ng-option>
	</ng-select>

	<ng-select
		appearance="outline"
		[(ngModel)]="filters.boards"
		[multiple]="true"
		class="form-filter"
		placeholder="Wyżywienie"
		(change)="setFilters()"
	>
		<ng-option *ngFor="let board of store.boards" [value]="board.id">{{ board.name }}</ng-option>
	</ng-select>

	<mat-form-field class="form-filter" appearance="outline">
		<mat-label>Uczestnicy</mat-label>
		<input
			type="number"
			(change)="setFilters()"
			[(ngModel)]="filters.slots"
			[value]="filters?.slots?.toString()"
			matInput
		/>
	</mat-form-field>

	<ng-select
		[(ngModel)]="filters.productKinds"
		[multiple]="true"
		(change)="setFilters()"
		appearance="outline"
		class="form-filter"
		placeholder="Rodzaj wycieczki"
	>
		<ng-option *ngFor="let productKind of store.productKinds" [value]="productKind.id">{{
			productKind.name
		}}</ng-option>
	</ng-select>

	<ng-select
		appearance="outline"
		class="form-filter"
		[(ngModel)]="filters.products"
		[multiple]="true"
		(change)="setFilters()"
		placeholder="Produkt"
	>
		<ng-option *ngFor="let product of store.products" [value]="product.id">{{ product.name }}</ng-option>
	</ng-select>

	<ng-select
		[(ngModel)]="filters.promotion"
		[multiple]="true"
		(change)="setFilters()"
		appearance="outline"
		class="form-filter"
		placeholder="Promocje"
	>
		<ng-option *ngFor="let promotion of store.promotions" [value]="promotion.id">{{ promotion.name }}</ng-option>
	</ng-select>
</div>
<div [ngClass]="{ 'd-none': !sortedOffers.length }" style="height: 320px" class="overflow-auto">
	<mat-expansion-panel *ngFor="let item of offersSubject | async; let i = index" class="my-3">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<h4>
					{{ item[0].product.name }}
					(opłata programowa:
					{{ item[0].surchargeFee || 0 | price }}
					@if (item[0].surchargeCurrency) {
						{{ item[0].surchargeCurrency?.code }}
					}
					)
				</h4>
			</mat-panel-title>
		</mat-expansion-panel-header>

		<table class="w-100" mat-table [dataSource]="item">
			<ng-container matColumnDef="select">
				<th mat-header-cell *matHeaderCellDef>
					<mat-checkbox
						color="primary"
						(change)="$event ? toggleAllRows(i) : null"
						[checked]="selection.hasValue() && isAllSelected(i)"
						[indeterminate]="selection.hasValue() && !isAllSelected(i)"
						[aria-label]="checkboxLabel()"
					>
					</mat-checkbox>
				</th>
				<td mat-cell *matCellDef="let row">
					<mat-checkbox
						color="primary"
						(click)="$event.stopPropagation()"
						(change)="$event ? selection.toggle(row) : null"
						[checked]="selection.isSelected(row)"
						[aria-label]="checkboxLabel(row)"
					>
					</mat-checkbox>
				</td>
			</ng-container>

			<ng-container matColumnDef="term">
				<th mat-header-cell *matHeaderCellDef>Termin</th>
				<td mat-cell *matCellDef="let element">
					<div *ngIf="element.dateRange.lower === element.dateRange.upper">
						{{ element.dateRange.lower }}
						(Ilość nocy:
						{{ element.nightsStay }})
					</div>
					<div *ngIf="element.dateRange.lower !== element.dateRange.upper">
						{{ element.dateRange.lower }}
						-
						{{ element.dateRange.upper }}
						(Ilość nocy:
						{{ element.nightsStay }})
					</div>
				</td>
			</ng-container>

			<ng-container matColumnDef="roomType">
				<th mat-header-cell *matHeaderCellDef>Typ pokoju</th>
				<td mat-cell *matCellDef="let element">
					{{ element.roomType.name }}
				</td>
			</ng-container>

			<ng-container matColumnDef="city">
				<th mat-header-cell *matHeaderCellDef>Miasto wyjazdu</th>
				<td mat-cell *matCellDef="let element">
					{{ element.stop ? element.stop.name : 'Dojazd własny' }}
				</td>
			</ng-container>

			<ng-container matColumnDef="board">
				<th mat-header-cell *matHeaderCellDef>Wyżywienie</th>
				<td mat-cell *matCellDef="let element">
					{{ element.board.name }}
				</td>
			</ng-container>

			<ng-container matColumnDef="currentPrice">
				<th mat-header-cell *matHeaderCellDef>Aktualna Cena</th>
				<td mat-cell *matCellDef="let element">{{ element.fullPrice | price }} PLN</td>
			</ng-container>

			<ng-container matColumnDef="promotion">
				<th mat-header-cell *matHeaderCellDef>Promocja</th>
				<td mat-cell *matCellDef="let element">
					{{ element?.promotion?.catalog.name }}
				</td>
			</ng-container>

			<ng-container matColumnDef="price">
				<th mat-header-cell *matHeaderCellDef>Cena</th>
				<td
					[ngClass]="{
						'bg-danger': element.priceDiff < 0,
						'text-white': element.priceDiff !== 0,
						'text-black': element.priceDiff === 0,
						'bg-success': element.priceDiff > 0,
					}"
					mat-cell
					*matCellDef="let element"
				>
					{{ element.priceDiff | price }} PLN
				</td>
			</ng-container>

			<ng-container matColumnDef="transport">
				<th mat-header-cell *matHeaderCellDef>Transport</th>
				<td mat-cell *matCellDef="let element">
					{{ element.transport }}
				</td>
			</ng-container>

			<ng-container matColumnDef="departure">
				<th mat-header-cell *matHeaderCellDef>Zakwaterowanie</th>
				<td mat-cell *matCellDef="let element">
					{{ element.departure }}
				</td>
			</ng-container>

			<ng-container matColumnDef="buttons">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element">
					<button
						class="changeToButtons"
						(click)="openChangeOfferDialog(element)"
						mat-raised-button
						color="primary"
					>
						{{ data.type === 'change' ? 'Zmień na' : 'Dodaj pokój' }}
					</button>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	</mat-expansion-panel>
</div>

<h3 *ngIf="!sortedOffers.length" class="d-flex justify-content-center align-items-center" style="height: 320px">
	Brak danych
</h3>
<div class="d-flex justify-content-end align-items-center">
	<div
		*ngIf="offersNumber === offersLimit"
		class="bg-warning text-white d-flex justify-content-between align-items-center text-center w-100 py-2 rounded-1 me-3"
	>
		<i class="fas fa-exclamation-triangle px-3"></i>Ofert jest więcej! Aby zobaczyć wszystkie zawęż kryteria
		wyszukiwania<i class="fas fa-exclamation-triangle px-3"></i>
	</div>
	<mat-paginator class="offer-change-paginator" [pageSizeOptions]="[3, 6]" showFirstLastButtons> </mat-paginator>
</div>
